import styled from 'styled-components';
import { DARKER, PRIMARY, SECONDARY } from '../../const/colors';
import { mobile_title } from '../../const/fonts';

export const Container = styled.div`
  width: 600px;
  background-color: ${DARKER};

  @media screen and (max-width: 768px) {
    width: calc(100%);
  }
`;

export const Table = styled.table`
  font-size: 0.9rem;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;

  max-width: 100%;
  white-space: wrap;
  td, th {
    text-align: center;
    padding: 8px;
  }

  td {
    font-size: 12px;
    color: #ffffff;
  }

  thead, th {
    color: ${SECONDARY};
    //background: ${PRIMARY};
    background-color: #fff;
  }
  tbody tr:nth-child(odd) {
    background: ${DARKER};
  }
  tbody tr:nth-child(even) {
    background: ${SECONDARY};
  }

  tr.row {
    transition: background-color 0.1s linear;
  }
  tr.row:hover {
    cursor: pointer;
    background-color: #222;
  }

  td span {
    width: 100%;
    display: inline-block;
    padding: 5px;
    font-weight: bold;
  }
  td.danger span {
    background: #C21010;
  }
  td.primary span {
    background: #007bff;
  }
  td.dark span {
    background: #444;
  }
  td.success span {
    background: #28a745;
  }
  td.warning span {
    background-color: #ffc107;
    color: ${SECONDARY};
  }

/*   @media (max-width: 767px) {
    display: block;
    width: 100%;
   thead, tbody, thead th {
      display: block;
    }
   thead th:last-child{
      border-bottom: none;
    }
   thead {
      float: left;
    }
   tbody {
      width: auto;
      position: relative;
      overflow-x: auto;
    }
   td, th {
      padding: 20px .625em .625em .625em;
      height: 60px;
      vertical-align: middle;
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;
      width: 120px;
      font-size: 13px;
      text-overflow: ellipsis;
    }
   thead th {
      text-align: left;
      border-bottom: 1px solid #f7f7f9;
    }
   tbody tr {
      display: table-cell;
    }
   tbody tr:nth-child(odd) {
    background: ${DARKER};
    }
   tbody tr:nth-child(even) {
    background: ${SECONDARY};
    }
   tbody td {
      display: block;
      text-align: center;
    }

    td span {
      font-size: 11px;
    }
} */
`;

export const ButtonClose = styled.button`
	border: none;
	background-color: #fff;
	color: ${SECONDARY};
	padding: 0.2rem 0.5rem;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
  margin-left: auto;
  position: absolute;
  right: 0;
  top: 0;
	svg {
		font-size: 2.5rem;
	}
	&:hover {
		background-color: #93291E;
		svg {
			color: #fff;
		}
	}
  @media screen and (max-width: 768px) {
    position: relative;

    svg {
      font-size: 2rem;
    }
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${PRIMARY};
  position: relative;

  h2 {
    padding: 0.7rem;
    margin: 0 auto;
    color: ${SECONDARY};
    font-weight: 800;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    h2 {
      font-size: ${mobile_title};
      padding: 0;

    }
  }
  @media screen and (max-width: 480px) {
    margin-bottom: 0;
  }
`;

export const BonosContainer = styled.div`
  max-height: calc(60vh);
  min-height: calc(20vh);
  overflow-y: auto;
  border-top: 1px solid ${DARKER};

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
      background: ${DARKER};
      border-radius: 0;
  }
  ::-webkit-scrollbar-thumb {
    background: ${PRIMARY};
    border-radius: 0;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${PRIMARY}99;
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  }
  ::-webkit-scrollbar-thumb:active {
    background-color: #999999;
  }

  .no_bono {
    font-weight: bold;
    color:#fff;
    min-height: 200px;
    text-align: center;
    margin-top: 1rem;
  }

  @media screen and (max-width:768px) {
    overflow-x: scroll;
  }

`

export const Bono = styled.div`
  width: 400px;
  h2 {
    font-size: 1.26rem;
  }

  svg {
    font-size: 2.25rem;
  }
  background-color: ${SECONDARY};

  @media screen and (max-width: 768px) {
    width: calc(100%);

    h2 {
      font-size: 1rem;
    }
  }
`;
export const BonoContent = styled.div`
  color: #fff;
  font-weight: bold;

  p {
    text-align: center;
    margin: 0.5rem 0;
  }
  .between {
    display: flex;
    justify-content: space-between;
  }
  div,p {
    padding: 0.5rem;
  }
  .bg {
    background-color: ${DARKER};
  }
  div {
    font-size: 0.8rem;
  }

  h3 {
    text-align: center;
    text-transform: uppercase;
    padding: 1rem 0;
  }

  .body .between > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .span {
      font-weight: normal;
      margin-top: 0.5rem;
    }
  }

  .estado {
    text-align: center;
    padding: 1rem;
    span {
      padding: 0.5rem;
      border-radius: 0.5rem;
    }
  }

  span.danger {
    background: #C21010;
  }
  span.primary {
    background: #007bff;
  }
  span.dark {
    background: #444;
  }
  span.success {
    background: #28a745;
  }
  span.warning {
    background-color: #ffc107;
    color: ${SECONDARY};
  }

  @media screen and (max-width: 480px) {
    p, div {
      font-size: 0.7rem;
    }
  }
`;